import React from 'react';
import { useChartScales } from './charts/ChartScales';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { DEFAULT_MARGINS } from './hooks/useMargins';
import { createSafeStylesAccessor } from './helpers/cssHelpers';

function Title({ chartType }) {
  const { get, meta } = useReportConfiguration();
  const title = get('chartTitle');
  const safeStyles = createSafeStylesAccessor(get() || {});
  const format = safeStyles.getTitleFormat();
  const { margins } = useChartScales();
  if (!title || meta.hideTitle) return null;

  let leftMargin;
  if (chartType === 'PieChart') {
    leftMargin = DEFAULT_MARGINS.SMALL;
  } else {
    leftMargin = margins.left;
  }

  return (
    <span
      className='custom-chart-title'
      style={{ left: leftMargin, ...format }}
    >
      {title}
    </span>
  );
}

export default Title;
